import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlightSearch',
    standalone: false
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: any, args: any): any {
    if (!args) {
      return value;
    }

    const regex = new RegExp(args, 'gi');

    if (!value.match(regex)) {
      return value;
    }

    return value.replace(regex, match => {
      return `<span class='highlight'>${match}</span>`;
    });
  }
}
